module.exports = __webpack_public_path__ + "media/images/icon__burger-menu-661ffc832cac27240bfca919eecef918.png";